<template>
  <f7-page class="profile-settings popup-auth">
    <f7-navbar>
      <f7-nav-left>
        <f7-link back>
          <f7-icon f7="chevron_left" size="16"></f7-icon>
          {{ $t(`back`) }}
        </f7-link>
      </f7-nav-left>

      <f7-nav-title>{{ $t(`page_profile.profile_setting`) }}</f7-nav-title>
    </f7-navbar>

    <div class="page-content-inner">
      <f7-list class="popup-auth-list" no-hairlines>
        <f7-list-input
          type="text"
          floating-label
          clear-button
          :label="$t(`form_fields.name.placeholder`)"
          :error-message-force="!!name.error"
          :error-message="name.error"
          :value="name.value"
          @input="name.value = $event.target.value"
        ></f7-list-input>

        <f7-list-input
          type="text"
          floating-label
          clear-button
          :label="$t(`form_fields.last_name.placeholder`)"
          :error-message-force="!!lastName.error"
          :error-message="lastName.error"
          :value="lastName.value"
          @input="lastName.value = $event.target.value"
        ></f7-list-input>

        <f7-list-input
          type="email"
          inputmode="email"
          floating-label
          clear-button
          :label="$t(`form_fields.email.placeholder`)"
          :error-message-force="!!email.error"
          :error-message="email.error"
          :value="email.value"
          @input="email.value = $event.target.value"
        ></f7-list-input>
      </f7-list>

      <f7-list class="popup-auth-list" no-hairlines>
        <f7-list-item>
          <span>{{ $t(`visible_history`) }}</span>
          <f7-toggle
            :checked="shareHistory"
            @toggle:change="(e) => (shareHistory = e)"
          ></f7-toggle>
        </f7-list-item>
      </f7-list>

      <f7-block class="mt-auto">
        <f7-button
          fill
          large
          class="custome-large display-flex justify-content-space-between gradient"
          @click="send"
        >
          {{ $t(`page_profile.change_data`) }}
          <f7-preloader v-if="loading" color="white"></f7-preloader>
          <f7-icon v-else f7="arrow_right" color="white" size="24"></f7-icon>
        </f7-button>
      </f7-block>
    </div>
  </f7-page>
</template>

<script>
import { merge, isEmpty } from 'lodash';
import { mapActions, mapState } from 'vuex';

import apiRequest from '@/js/helpers/apiRequest.js';
import validateEmail from '@/js/helpers/validateEmail.js';
import notify from '@/js/helpers/notify.js';

export default {
  name: 'ChangeProfile',

  data() {
    return {
      loading: false,
      name: { value: '', error: null },
      lastName: { value: '', error: null },
      email: { value: '', error: null },
      shareHistory: false
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user.info
    })
  },

  created() {
    const { name, lastName, email, shareHistory } = this.user;

    name ? (this.name.value = name) : null;
    lastName ? (this.lastName.value = lastName) : null;
    email ? (this.email.value = email) : null;
    this.shareHistory = shareHistory;
  },

  mounted() {
    document
      .querySelector('.navbar')
      .style.setProperty('--f7-navbar-bg-color', 'transparent');
  },

  beforeDestroy() {
    document
      .querySelector('.navbar')
      .style.setProperty('--f7-navbar-bg-color', '#ffffff');
  },

  methods: {
    validate() {
      const errors = {};
      const { name, lastName, email } = this;

      // Reset old erorors
      name.error = null;
      lastName.error = null;
      email.error = null;

      if (!name.value) {
        errors.name = this.$t(`form_fields.errors.enter_name`);
      }

      if (!lastName.value) {
        errors.lastName = this.$t(`form_fields.errors.enter_last_name`);
      }

      if (!validateEmail(email.value)) {
        errors.email = this.$t(`form_fields.errors.enter_correct_email`);
      }

      if (!email.value) {
        errors.email = this.$t(`form_fields.errors.enter_email`);
      }

      if (isEmpty(errors)) {
        return true;
      }

      // Formating
      Object.keys(errors).forEach((error) => {
        errors[error] = {
          error: errors[error]
        };
      });

      merge(this.name, errors.name);
      merge(this.lastName, errors.lastName);
      merge(this.email, errors.email);
    },

    async send() {
      if (!this.validate()) {
        return;
      }

      const { name, lastName, email, shareHistory } = this;
      this.loading = true;

      try {
        const body = new FormData();
        body.append('name', name.value);
        body.append('last_name', lastName.value);
        body.append('email', email.value);
        body.append('share_history', Number(shareHistory));

        const res = await apiRequest('saveUserData', 'POST', body, true);

        if (res.error) {
          throw { customeError: res.error };
        }

        await this.getUserInfo();

        this.loading = false;

        notify({ text: this.$t(`notify.profile_changed`) });
      } catch (error) {
        this.loading = false;

        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          notify({ text: this.$t(`notify.something_went_wrong`) });
        }
      }
    },

    ...mapActions({
      setUserData: 'auth/setUserData',
      getUserInfo: 'user/getUserInfo'
    })
  }
};
</script>

<style lang="less">
.profile-settings {
  input {
    text-align: left !important;
  }

  &-bg-image {
    position: absolute;
    top: -100px;
    left: 0;
    width: 100%;
    height: auto;
  }
}
</style>
